var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackpack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4C20.5523 4 21 4.44772 21 5V9C21 9.55228 20.5523 10 20 10C19.4477 10 19 9.55228 19 9V5C19 4.44772 19.4477 4 20 4ZM8.29289 7.29289C8.68342 6.90237 9.31658 6.90237 9.70711 7.29289L12.7071 10.2929C13.0976 10.6834 13.0976 11.3166 12.7071 11.7071C12.3166 12.0976 11.6834 12.0976 11.2929 11.7071L8.29289 8.70711C7.90237 8.31658 7.90237 7.68342 8.29289 7.29289ZM30.7071 7.29289C31.0976 7.68342 31.0976 8.31658 30.7071 8.70711L27.7071 11.7071C27.3166 12.0976 26.6834 12.0976 26.2929 11.7071C25.9024 11.3166 25.9024 10.6834 26.2929 10.2929L29.2929 7.29289C29.6834 6.90237 30.3166 6.90237 30.7071 7.29289ZM13.7656 16C13.2612 16 12.8358 16.3755 12.7733 16.876L11.1328 30H28.8672L27.2267 16.876C27.1642 16.3755 26.7388 16 26.2344 16H13.7656ZM30.8828 30L29.2113 16.6279C29.0236 15.1266 27.7474 14 26.2344 14H13.7656C12.2526 14 10.9764 15.1266 10.7887 16.6279L9.11722 30H7C6.44772 30 6 30.4477 6 31V35C6 35.5523 6.44772 36 7 36H33C33.5523 36 34 35.5523 34 35V31C34 30.4477 33.5523 30 33 30H30.8828ZM2 17C2 16.4477 2.44772 16 3 16H7C7.55228 16 8 16.4477 8 17C8 17.5523 7.55228 18 7 18H3C2.44772 18 2 17.5523 2 17ZM32 17C32 16.4477 32.4477 16 33 16H37C37.5523 16 38 16.4477 38 17C38 17.5523 37.5523 18 37 18H33C32.4477 18 32 17.5523 32 17ZM20 19C20.5523 19 21 19.4477 21 20V22H23C23.5523 22 24 22.4477 24 23C24 23.5523 23.5523 24 23 24H21V26C21 26.5523 20.5523 27 20 27C19.4477 27 19 26.5523 19 26V24H17C16.4477 24 16 23.5523 16 23C16 22.4477 16.4477 22 17 22H19V20C19 19.4477 19.4477 19 20 19ZM8 32V34H32V32H8Z",
    fill: "#006FCF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackpack);
export default __webpack_public_path__ + "static/media/backpack.5c3a33149b902ffb51c0797061127c16.svg";
export { ForwardRef as ReactComponent };